module.exports = __webpack_public_path__ + "img/cocteleria_6.dd89c227.jpeg";